import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './Pages/Main';
import Login from './Pages/Login';
import Registration from './Pages/Registration';
import Confirm from './Pages/Confirm';
import Recovery from './Pages/Recovery';
import Calculator from './Pages/Calculator';
import Cases from './Pages/Cases';
import BlogPage from './Pages/Blog';
import Art from './Pages/Article'
import NotFound from './Pages/NotFound';
import IndustriesPage from './Pages/Industries';
import LkApp from './Pages/PrimaryAccount';
import CasePage from './Pages/Case';
import PasswordResetCode from './Pages/PasswordResetCode';
import PasswordResetConfirm from './Pages/PasswordResetConfirm';
import Cookies from 'js-cookie';

const App = () => {
  // console.log('Token:', document.cookie);

  const [authorized, setAuthorized] = useState(false); // Авторизован пользователь или нет

  useEffect(() => {
    const token = Cookies.get('token');
    console.log('Token:', token); // Логируем токен
    console.log('Token:', document.cookie);
    if (token) {
        setAuthorized(true);
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main authorized={authorized} setAuthorized={setAuthorized} />} />
        <Route path="/primary" element={<LkApp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/confirm" element={<Confirm />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/calculator" element={<Calculator authorized={authorized} setAuthorized={setAuthorized} />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<Art />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/cases/:id" element={<CasePage />} />
        <Route path="/industries/:id" element={<IndustriesPage />} />
        <Route path="/password-reset-code" element={<PasswordResetCode />} />
        <Route path="/password-reset-confirm" element={<PasswordResetConfirm />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
